import { TransportationOption, TransportationOptionResource } from './TransportationOption'

export const transformToTransportationOptions = (items: TransportationOptionResource[]): TransportationOption[] => items.map(resource => ({
    id: resource.id,
    name: resource.attributes.name,
}))
